function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { colors } from "../../../styleguide";
import { useCloseOnEsc } from '@weahead/react-customizable-modal';
import ShowMoreButton from "../../ShowMoreButton";
import * as BigAssCategoryPickerUI from "./BigAssCategoryPicker.styles";
import Categories from "./Categories";

var BigAssCategoryPicker = function BigAssCategoryPicker(_ref) {
  var categories = _ref.categories,
      onCategoryClick = _ref.onCategoryClick,
      onCategoriesButtonClick = _ref.onCategoriesButtonClick,
      linkComponent = _ref.linkComponent;
  var ref = useRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showBigAssCategoryPicker = _useState2[0],
      setShowBigAssCategoryPicker = _useState2[1];

  var toggleBigAss = function toggleBigAss() {
    return setShowBigAssCategoryPicker(function (prevState) {
      return !prevState;
    });
  };

  var handleOnCategoryClick = function handleOnCategoryClick(categoryName) {
    if (onCategoryClick) {
      onCategoryClick(categoryName);
    }

    toggleBigAss();
  };

  var handleOnCategoriesButtonClick = function handleOnCategoriesButtonClick() {
    if (onCategoriesButtonClick && !showBigAssCategoryPicker) {
      onCategoriesButtonClick();
    }

    toggleBigAss();
  };

  useEffect(function () {
    var handleOnOutsideClick = function handleOnOutsideClick(event) {
      if (ref && ref.current && !ref.current.contains(event.target)) {
        setShowBigAssCategoryPicker(false);
      }
    };

    document.addEventListener('click', handleOnOutsideClick, true);
    return function () {
      document.removeEventListener('click', handleOnOutsideClick, true);
    };
  }, []);
  useCloseOnEsc(function () {
    setShowBigAssCategoryPicker(false);
  });

  if (!categories) {
    return null;
  }

  return /*#__PURE__*/React.createElement(BigAssCategoryPickerUI.Container, {
    ref: ref
  }, /*#__PURE__*/React.createElement(ShowMoreButton, {
    "aria-controls": "big-ass-category-picker",
    "aria-expanded": showBigAssCategoryPicker,
    onClick: handleOnCategoriesButtonClick,
    isOpenLabel: "Kategorier",
    isClosedLabel: "Kategorier",
    closed: !showBigAssCategoryPicker,
    color: colors.grey800,
    labelStyle: {
      fontSize: '15px'
    }
  }), showBigAssCategoryPicker && /*#__PURE__*/React.createElement(BigAssCategoryPickerUI.MenuPositioner, null, /*#__PURE__*/React.createElement(BigAssCategoryPickerUI.Frame, {
    role: "dialog",
    "aria-modal": "true",
    id: "big-ass-category-picker",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(Categories, {
    categories: categories,
    onCategoryClick: handleOnCategoryClick,
    linkComponent: linkComponent
  }))));
};

BigAssCategoryPicker.propTypes = process.env.NODE_ENV !== "production" ? {
  onCategoriesButtonClick: PropTypes.func,
  onCategoryClick: PropTypes.func,
  categories: PropTypes.array,
  linkComponent: PropTypes.elementType
} : {};
export default BigAssCategoryPicker;
//# sourceMappingURL=BigAssCategoryPicker.js.map